import * as React from "react"
import { Typography } from "@mui/material"
import { formatPercentage } from "@ui-seeker/utils/"

import { NotAllowedBlock, SkuLabel } from "@components"
import { adminScrapingDataReviewPercentageData } from "../../../@signals"


export default function productTitleColumn() {
	return {
		name: "productName",
		label: `Product Title (${formatPercentage(adminScrapingDataReviewPercentageData.value["percentageProductTitle"], { decimals: 2 })})`,
		options: {
			display: false,
			filter: false,
			setCellHeaderProps: () => ({
                sx: {
                    textAlign: "center",
                    minWidth: 80,
                    borderRight: "1px solid",
                    borderColor: "divider"
                }
            }),
			setCellProps: () => ({
                sx: {
                    textAlign: "center",
                    borderRight: "1px solid",
                    borderColor: "divider"
                }
            }),
			customBodyRowRender: value => <Typography variant="body2" >
                <SkuLabel label={value ? value : <NotAllowedBlock />} ellipsis maxWidth={300} />
            </Typography>
		}
	}
}